export const splashImgDimensions = { width: 400, height: 400 };
